(() => {
  'use strict';
  const historyKey = 'beerclub-viewed-session-v1';
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', { style: 'currency', currency }).format(cents / 100);
  function updatePix(scope, total, currency, valid) {
    const pix = scope.querySelector('[data-pix-price]');
    if (!pix) return;
    const percent = Number(pix.dataset.pixPercent);
    const eligible = valid && total > 0 && Number.isFinite(percent) && percent > 0 && percent <= 100;
    pix.hidden = !eligible;
    pix.querySelector('[data-pix-total]').textContent = eligible ? money(Math.round(total * (100 - percent) / 100), currency) : '';
  }
  function mainSelection() {
    const form = document.querySelector('.native-product-form');
    if (!form) return null;
    const scope = form.closest('[data-product-price]');
    const plan = form.querySelector('[name="selling_plan"] option:checked');
    const quantityInput = form.querySelector('[name="quantity"]');
    if (!quantityInput) return null;
    const unitPrice = form.querySelector('[data-purchase-unit-price]');
    return {
      form,
      quantityInput,
      price: Number(plan?.dataset.price ?? scope?.dataset.productPrice ?? 0),
      quantity: Number(quantityInput.value),
      currency: scope?.dataset.currency || 'BRL',
      comparePrice: Number(plan?.dataset.comparePrice ?? scope?.dataset.productComparePrice ?? 0),
      unitPrice: Number(plan?.dataset.unitPrice ?? unitPrice?.dataset.unitPrice ?? 0)
    };
  }
  function update() {
    document.querySelectorAll('[data-quantity-control]').forEach(control => {
      const input = control.querySelector('input');
      const value = Number(input.value), step = Number(input.step || 1), min = Number(input.min || 1), max = input.max ? Number(input.max) : Infinity;
      control.querySelector('[data-quantity-step="-1"]').disabled = input.disabled || value - step < min;
      control.querySelector('[data-quantity-step="1"]').disabled = input.disabled || value + step > max;
    });
    document.querySelectorAll('[data-card-price]').forEach(priceBlock => {
      const input = priceBlock.closest('.product-card').querySelector('[name="quantity"]');
      if (!input) return;
      const quantity = Number(input.value), price = Number(priceBlock.dataset.cardPrice), compare = Number(priceBlock.dataset.cardCompare);
      const valid = input.value !== '' && input.validity.valid && quantity > 0 && Number.isFinite(price * quantity);
      const currency = priceBlock.dataset.currency || 'BRL';
      updatePix(priceBlock, price * quantity, currency, valid);
      priceBlock.querySelector('[data-card-total]').textContent = valid ? money(price * quantity, currency) : '—';
      const previous = priceBlock.querySelector('[data-card-compare-total]');
      previous.hidden = !valid || compare <= price;
      previous.textContent = previous.hidden ? '' : money(compare * quantity, currency);
      const installments = priceBlock.querySelector('[data-card-installments]');
      installments.hidden = !valid || price * quantity <= 0;
      priceBlock.querySelector('[data-card-installment-value]').textContent = valid ? money(Math.round(price * quantity / 3), currency) : '—';
      const context = priceBlock.querySelector('[data-card-quantity-label]');
      context.hidden = !valid || quantity <= 1;
      context.textContent = valid ? 'Total para ' + quantity + ' unidades' : '';
    });
    const main = mainSelection();
    if (!main) return;
    const label = main.form.querySelector('[data-add-label]');
    const inlineTotal = main.form.querySelector('[data-purchase-total]');
    // Required app properties must not hide a valid product price while being filled.
    const valid = main.quantityInput.value !== '' && main.quantityInput.validity.valid && main.quantity > 0 && Number.isFinite(main.price * main.quantity);
    updatePix(main.form, main.price * main.quantity, main.currency, valid);
    if (inlineTotal) {
      inlineTotal.textContent = valid ? money(main.price * main.quantity, main.currency) : '—';
      const compare = main.form.querySelector('[data-purchase-compare]');
      if (compare) {
        compare.hidden = !valid || !Number.isFinite(main.comparePrice) || main.comparePrice <= main.price;
        compare.textContent = !compare.hidden ? money(main.comparePrice * main.quantity, main.currency) : '';
      }
      const installments = main.form.querySelector('[data-purchase-installments]');
      if (installments) {
        installments.hidden = !valid || main.price * main.quantity <= 0;
        installments.querySelector('[data-purchase-installment-value]').textContent = valid ? money(Math.round(main.price * main.quantity / 3), main.currency) : '—';
      }
      const quantityLabel = main.form.querySelector('[data-purchase-quantity-label]');
      if (quantityLabel) {
        quantityLabel.hidden = !valid || main.quantity <= 1;
        quantityLabel.textContent = valid ? 'Total para ' + main.quantity + ' unidades' : '';
      }
      const unitPrice = main.form.querySelector('[data-purchase-unit-price]');
      if (unitPrice) unitPrice.textContent = Number.isFinite(main.unitPrice) ? money(main.unitPrice, main.currency) : '—';
      if (label) label.textContent = 'Comprar';
    } else if (label) label.textContent = valid ? 'Adicionar — ' + money(main.price * main.quantity, main.currency) : 'Adicionar à sacola';
    document.querySelectorAll('[data-bundle]').forEach(section => {
      const selected = [...section.querySelectorAll('[data-bundle-option]:checked')];
      const total = main.price * main.quantity + selected.reduce((sum, input) => sum + Number(input.dataset.price) * Number(input.dataset.quantity), 0);
      const output = section.querySelector('[data-bundle-total]');
      if (output) output.textContent = Number.isFinite(total) ? money(total, main.currency) : 'Confira a quantidade';
      const button = section.querySelector('[data-bundle-add]');
      const fileInput = main.form.querySelector('input[type="file"]');
      const allowed = main.form.checkValidity() && !main.form.querySelector('[name="add"]')?.disabled && !fileInput;
      if (button && !button.hasAttribute('data-cart-locked')) button.disabled = selected.length === 0 || !allowed;
    });
  }
  document.addEventListener('click', event => {
    const stepper = event.target.closest('[data-quantity-step]');
    if (stepper) {
      const input = stepper.closest('[data-quantity-control]').querySelector('input');
      if (stepper.dataset.quantityStep === '1') input.stepUp(); else input.stepDown();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      // Drawer changes are submitted by the shared change listener.
    }
    const clear = event.target.closest('[data-clear-recent]');
    if (clear) {
      try { sessionStorage.removeItem(historyKey); } catch { /* Storage may be unavailable. */ }
      clear.closest('[data-recent-products]').hidden = true;
    }
  });
  document.addEventListener('input', update);
  document.addEventListener('change', update);
  document.addEventListener('beerclub:cart-updated', update);
  document.addEventListener('beerclub:products-loaded', update);
  async function recent(section) {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const current = section.dataset.currentHandle;
    let history;
    try {
      const saved = JSON.parse(sessionStorage.getItem(historyKey) || '[]');
      history = (Array.isArray(saved) ? saved : []).filter(handle => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(handle) && handle !== current);
      history = [...new Set(history)].slice(0, 8);
      sessionStorage.setItem(historyKey, JSON.stringify([current, ...history].slice(0, 9)));
    } catch { return; }
    const root = section.dataset.root.replace(/\/?$/, '/');
    const cards = await Promise.all(history.slice(0, Number(section.dataset.limit)).map(async handle => {
      try {
        const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=recent-product-card', { signal: AbortSignal.timeout(8000) });
        if (!response.ok) return null;
        return new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('.product-card');
      } catch { return null; }
    }));
    const grid = section.querySelector('[data-recent-grid]');
    cards.filter(Boolean).forEach(card => grid.append(card));
    section.hidden = !grid.children.length;
    update();
  }
  function init() { update(); document.querySelectorAll('[data-recent-products]').forEach(recent); }
  document.addEventListener('shopify:section:load', init);
  init();
})();
